import { createServerFn } from '@tanstack/react-start';
import { setCookie } from '@tanstack/react-start/server';

import { readExternalSession, renewExternalSession } from './external-session';

/** What a page may know about this browser's external session for a project. */
export type ExternalSessionSummary = {
  userId: string;
  completed: boolean;
};

/**
 * This browser's external session for a project, for route guards and
 * loaders. Renews the sliding expiry while the study is in progress.
 */
export const getExternalSession = createServerFn()
  .validator((data: { projectId: string }) => data)
  .handler(async ({ data }): Promise<ExternalSessionSummary | null> => {
    const found = await readExternalSession(data.projectId);
    if (!found) {
      return null;
    }

    renewExternalSession(found.sessionId, found.session, setCookie);

    return {
      userId: found.session.userId,
      completed: found.session.completedAt !== null,
    };
  });
